module.exports = __webpack_public_path__ + "static/media/icon_environment.91c8857c.svg";